import React, { useState } from 'react';
import { IconButton, Button } from "@material-tailwind/react"; // Added Button
import { HomeIcon, ChatBubbleOvalLeftIcon, UserIcon, MagnifyingGlassIcon, XCircleIcon, QrCodeIcon, ChartBarIcon, XMarkIcon } from "@heroicons/react/24/outline"; // Added XMarkIcon for close
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { isMaisterchefGermanTheme } from '../utils/branding';


// Accept props from App.js
const NavigationMenu = ({ language, t, onUnsubscribeClick }) => {
    const navigate = useNavigate();
    const location = useLocation();

    // Map Belgian language codes to french and nederlands for translations
    let displayLanguage = language;
    if (language === 'befr' || language === 'be-fr') displayLanguage = 'french';
    if (language === 'benl' || language === 'be-nl') displayLanguage = 'nederlands';
    if (language === 'bh-ar' || language === 'bahrain-arabic') displayLanguage = 'arabic';
    if (language === 'bh-en' || language === 'bahrain-english') displayLanguage = 'english';
    if (language === 'uae-ar' || language === 'uae-arabic') displayLanguage = 'arabic';
    if (language === 'uae-en' || language === 'uae-english') displayLanguage = 'english';
    if (language === 'sa-ar' || language === 'sa-arabic') displayLanguage = 'arabic';
    if (language === 'sa-en' || language === 'sa-english') displayLanguage = 'english';
    if (language === 'kw-ar' || language === 'kw-arabic') displayLanguage = 'arabic';
    if (language === 'kw-en' || language === 'kw-english') displayLanguage = 'english';
    if (language === 'qa-ar' || language === 'qa-arabic') displayLanguage = 'arabic';
    if (language === 'qa-en' || language === 'qa-english') displayLanguage = 'english';
    if (language === 'om-ar' || language === 'om-arabic') displayLanguage = 'arabic';
    if (language === 'om-en' || language === 'om-english') displayLanguage = 'english';
    if (language === 'iq-ar' || language === 'iq-arabic') displayLanguage = 'arabic';
    if (language === 'iq-en' || language === 'iq-english') displayLanguage = 'english';
    if (language === 'jo-ar' || language === 'jo-arabic') displayLanguage = 'arabic';
    if (language === 'jo-en' || language === 'jo-english') displayLanguage = 'english';
    if (language === 'lb-ar' || language === 'lb-arabic') displayLanguage = 'arabic';
    if (language === 'lb-en' || language === 'lb-english') displayLanguage = 'english';
    if (language === 'sy-ar' || language === 'sy-arabic') displayLanguage = 'arabic';
    if (language === 'sy-en' || language === 'sy-english') displayLanguage = 'english';
    if (language === 'ps-ar' || language === 'ps-arabic') displayLanguage = 'arabic';
    if (language === 'ps-en' || language === 'ps-english') displayLanguage = 'english';
    if (language === 'ye-ar' || language === 'ye-arabic') displayLanguage = 'arabic';
    if (language === 'ye-en' || language === 'ye-english') displayLanguage = 'english';
    if (language === 'eg-ar' || language === 'eg-arabic') displayLanguage = 'arabic';
    if (language === 'eg-en' || language === 'eg-english') displayLanguage = 'english';
    if (language === 'pl-pl') displayLanguage = 'polish';
    if (language === 'arabic') displayLanguage = 'arabic';

    // Check if language footer is visible (Belgian languages or German)
    const isLanguageFooterVisible = ['befr', 'benl', 'be-fr', 'be-nl', 'deutsch', 'portuguese'].includes(language);
    const bottomPosition = isLanguageFooterVisible ? 'bottom-8' : 'bottom-0';
    const mcDeTheme = isMaisterchefGermanTheme(language);

    const navClass = ({ isActive }) =>
        `flex flex-col items-center focus:bg-transparent hover:bg-transparent ${isActive ? 'mc-de-nav-active' : ''}`;

    if (mcDeTheme) {
        return (
            <div className={`mc-de-nav fixed ${bottomPosition} left-0 right-0 flex justify-around items-center z-50`}>
                <NavLink reloadDocument to="/" className={navClass}>
                    <HomeIcon className="h-5 w-5" />
                    <span className="mc-de-nav-label">{t.home || 'Start'}</span>
                </NavLink>
                <NavLink reloadDocument to="/chat" className={navClass}>
                    <ChatBubbleOvalLeftIcon className="h-5 w-5" />
                    <span className="mc-de-nav-label">Chat</span>
                </NavLink>
                <NavLink reloadDocument to="/nutritionGoals" className={navClass}>
                    <ChartBarIcon className="h-5 w-5" aria-hidden="true" />
                    <span className="mc-de-nav-label">{t.nutritionGoals || 'Ziele'}</span>
                </NavLink>
                <NavLink reloadDocument to="/search" className={navClass}>
                    {({ isActive }) => (
                        <span className={`mc-de-nav-search flex flex-col items-center px-3 py-1.5 ${isActive ? 'mc-de-nav-active' : ''}`}>
                            {location.pathname === '/search' ? (
                                <XMarkIcon className="h-5 w-5" />
                            ) : (
                                <MagnifyingGlassIcon className="h-5 w-5" />
                            )}
                            <span className="mc-de-nav-label">Suche</span>
                        </span>
                    )}
                </NavLink>
                <NavLink reloadDocument to="/shopping-list" className={navClass}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 494.64 494.64" fill="currentColor" aria-hidden="true">
                        <path d="M491.986 79.216c-2.775-4.641-7.351-7.895-12.631-8.957L199.171 2.712c-9.234-1.79-18.344 3.311-21.54 12.134L70.833 286.161l35.654 12.993 101.21-257.977L451.144 103.3c-15.204 47.134-51.383 145.512-86.064 237.112-30.236 79.921-47.635 107.289-80.705 112.878-.039-.039-.075-.077-.075-.135-67.586 9.474-66.373-76.688-66.373-76.688L2.076 289.276C-13.263 386.5 61.443 409.884 61.443 409.884l158.033 71.75c.038.02 24.708 11.771 51.521 10.563 72.323-1.703 97.739-54.218 129.585-138.352 46.008-121.594 92.705-257.838 93.164-259.283a18.772 18.772 0 00-1.76-15.346z"></path>
                    </svg>
                    <span className="mc-de-nav-label">{t.shoppingList}</span>
                </NavLink>
                <NavLink reloadDocument to="/barcodeScan" className={navClass}>
                    <QrCodeIcon className="h-5 w-5" aria-hidden="true" />
                    <span className="mc-de-nav-label">Scan</span>
                </NavLink>
                <NavLink reloadDocument to="/profile" className={navClass}>
                    <UserIcon className="h-5 w-5" />
                    <span className="mc-de-nav-label">{t.profile}</span>
                </NavLink>
            </div>
        );
    }

    return (
        <div className={`fixed ${bottomPosition} left-0 right-0 flex justify-around items-center bg-white py-2 px-4 shadow-lg z-50`}>

            {/* Conditionally render Unsubscribe button for Portuguese */}
            {language === 'portuguese' && (
                <Button
                    variant='text'
                    color="red" // Or gray if preferred
                    size="sm"
                    className="p-0 flex flex-col items-center text-red-500 hover:bg-transparent focus:bg-transparent" // Adjusted styling
                    onClick={() => navigate('/cancelar-subscricao')} // Navigate directly to the page instead of popup
                    style={{ // Add inline styles
                        width: '40px',
                        lineHeight: '1.1',
                        padding: '0',
                        margin: '0',
                        marginTop: '7px'
                    }}
                >
                    <XCircleIcon className="h-6 w-6" />
                    <span className="text-[7px]" style={{ // Add inline styles
                        width: '40px',
                        lineHeight: '1.1',
                        padding: '0',
                        margin: '0'
                    }}>{t.unsubscribe}</span> {/* Added text label */}
                </Button>
            )
            }

            {/* Home */}
            <NavLink reloadDocument to="/" className={({ isActive }) => `flex flex-col items-center focus:bg-transparent hover:bg-transparent`}>
                {({ isActive }) => (
                    <IconButton variant="text" color="gray" size="lg" className={`p-0 ${isActive ? 'text-green-500' : 'text-gray-600'}`}>
                        <HomeIcon className="h-6 w-6" />
                    </IconButton>
                )}
                {/* Optional: Add text label below icon */}
                {/* <span className="text-xs">Home</span> */}
            </NavLink>



            {/* Chat */}
            <NavLink reloadDocument to="/chat" className={({ isActive }) => `flex flex-col items-center focus:bg-transparent hover:bg-transparent`}>
                {({ isActive }) => (
                    <IconButton variant="text" color="gray" size="lg" className={`p-0 ${isActive ? 'text-green-500' : 'text-gray-600'}`}>
                        <ChatBubbleOvalLeftIcon className="h-6 w-6" />
                    </IconButton>
                )}
            </NavLink>

            <NavLink
                reloadDocument
                to="/nutritionGoals"
                className={({ isActive }) =>
                    `flex items-center justify-center p-2 rounded-md focus:bg-transparent hover:bg-transparent`
                }
            >
                {({ isActive }) => (
                    <ChartBarIcon className={`w-6 h-6 ${isActive ? 'text-green-500' : 'text-gray-600'}`} aria-hidden="true" />
                )}
            </NavLink>

            {/* Search (Middle Button) */}
            <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 rounded-full p-2 bg-white shadow-lg"> {/* Adjusted positioning */}
                {location.pathname === '/search' ? (
                    // Show X icon when on search page
                    <IconButton
                        color="red"
                        size='lg'
                        className="rounded-full bg-red-500"
                        onClick={() => navigate('/')}
                    >
                        <XMarkIcon className="h-7 w-7" />
                    </IconButton>
                ) : (
                    // Show search icon on other pages
                    <NavLink reloadDocument to="/search">
                        {({ isActive }) => (
                            <IconButton
                                color={isActive ? "green" : "black"}
                                size='lg'
                                className={`rounded-full ${isActive ? 'bg-green-500' : 'bg-black'}`}
                            >
                                <MagnifyingGlassIcon className="h-7 w-7" /> {/* Adjusted size */}
                            </IconButton>
                        )}
                    </NavLink>
                )}
            </div>

            {/* Spacer to push next items right */}
            <div className="w-16"></div> {/* Adjust width as needed */}


            {/* Shopping List */}
            <NavLink reloadDocument to="/shopping-list" className={({ isActive }) => `flex flex-col items-center focus:bg-transparent hover:bg-transparent`}>
                {({ isActive }) => (
                    <IconButton variant="text" color="gray" size="lg" className={`p-0 ${isActive ? 'text-green-500' : 'text-gray-600'}`}>
                        <svg // Keep existing SVG or replace with an icon if preferred
                            xmlns="http://www.w3.org/2000/svg"
                            width="24" // Adjusted size
                            height="24" // Adjusted size
                            version="1.1"
                            viewBox="0 0 494.64 494.64"
                            xmlSpace="preserve"
                            fill="currentColor" // Use currentColor to inherit NavLink color
                        >
                            <g>
                                <path d="M491.986 79.216c-2.775-4.641-7.351-7.895-12.631-8.957L199.171 2.712c-9.234-1.79-18.344 3.311-21.54 12.134L70.833 286.161l35.654 12.993 101.21-257.977L451.144 103.3c-15.204 47.134-51.383 145.512-86.064 237.112-30.236 79.921-47.635 107.289-80.705 112.878-.039-.039-.075-.077-.075-.135-67.586 9.474-66.373-76.688-66.373-76.688L2.076 289.276C-13.263 386.5 61.443 409.884 61.443 409.884l158.033 71.75c.038.02 24.708 11.771 51.521 10.563 72.323-1.703 97.739-54.218 129.585-138.352 46.008-121.594 92.705-257.838 93.164-259.283a18.772 18.772 0 00-1.76-15.346z"></path>
                                <path d="M364.272 188.63c1.646.45 3.35.689 5.033.689 8.324 0 15.94-5.55 18.274-13.971 2.774-10.115-3.216-20.564-13.317-23.32l-82.233-25.381c-9.989-2.765-20.555 3.177-23.311 13.282-2.757 10.114 3.178 20.564 13.318 23.33l82.236 25.371zM235.784 215.939c-3.296 9.962 2.055 20.69 11.989 24.015l81.802 29.232c1.986.661 3.938.958 5.907.969 7.979.042 15.453-4.991 18.117-12.96 3.305-9.935-2.036-20.679-12.01-24.002l-81.771-29.213c-9.993-3.307-20.699 2.043-24.034 11.959zM228.587 283.185c-9.952-3.33-20.698 2.104-23.952 12.096-3.272 9.914 2.182 20.67 12.134 23.923l81.973 29.111c1.975.669 3.942.956 5.936.956 7.961 0 15.387-5.07 18.01-13.033 3.271-9.971-2.163-20.707-12.115-23.961l-81.986-29.092zM225.552 104.517c11.617 0 21.043 9.167 21.043 20.459 0 11.301-9.426 20.458-21.043 20.458-11.626 0-21.052-9.158-21.052-20.458.001-11.292 9.426-20.459 21.052-20.459zM195.783 180.572c11.627 0 21.043 9.158 21.043 20.449 0 11.282-9.416 20.439-21.043 20.439-11.626 0-21.052-9.157-21.052-20.439 0-11.29 9.426-20.449 21.052-20.449zM164.033 259.039c11.627 0 21.052 9.168 21.052 20.479 0 11.29-9.425 20.438-21.052 20.438-11.626 0-21.052-9.146-21.052-20.438 0-11.311 9.426-20.479 21.052-20.479z"></path>
                            </g>
                        </svg>
                    </IconButton>
                )}
            </NavLink>

            <NavLink
                reloadDocument
                to="/barcodeScan"
                className={({ isActive }) =>
                    `flex items-center justify-center p-2 rounded-md focus:bg-transparent hover:bg-transparent`
                }
            >
                {({ isActive }) => (
                    <QrCodeIcon className={`w-6 h-6 ${isActive ? 'text-green-500' : 'text-gray-600'}`} aria-hidden="true" />
                )}
            </NavLink>

            {/* Profile */}
            <NavLink reloadDocument to="/profile" className={({ isActive }) => `flex flex-col items-center focus:bg-transparent hover:bg-transparent`}>
                {({ isActive }) => (
                    <IconButton variant="text" color="gray" size="lg" className={`p-0 ${isActive ? 'text-green-500' : 'text-gray-600'}`}>
                        <UserIcon className="h-6 w-6" />
                    </IconButton>
                )}
            </NavLink>


        </div >
    );
};

export default NavigationMenu;
